import { render, staticRenderFns } from "./Create-Supplier.vue?vue&type=template&id=6e93a9e4&scoped=true"
import script from "./Create-Supplier.vue?vue&type=script&lang=js"
export * from "./Create-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Create-Supplier.vue?vue&type=style&index=0&id=6e93a9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93a9e4",
  null
  
)

export default component.exports